var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcObesidad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 49,
    cy: 165,
    rx: 44,
    ry: 4,
    fill: "#DB0F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 28c7.732 0 14-6.268 14-14S56.732 0 49 0 35 6.268 35 14s6.268 14 14 14z",
    fill: "#DB0F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.805 164a7.37 7.37 0 0 1-7.365-7.365L22.2 84.157c-1.54-2.495-2.471-4.973-2.685-7.165a28.067 28.067 0 0 1-.128-3.576L13.318 85.42c-3.47 5.454-14.46 1.983-13.221-6.197l16.856-31.565C19.898 38.638 26.631 32 35.931 32l29.443.012c10.209 0 15.615 10.161 18.845 17.374l14.124 27.11c2.314 11.403-9.337 14.13-12.642 5.702l-4.716-9.907c.274 1.548.365 3.197.254 4.95-.19 2.993-1.187 5.974-2.87 8.74l-11.204 70.654A7.365 7.365 0 0 1 59.804 164a7.367 7.367 0 0 1-7.366-7.365l.018-52.128H49.18l-.008 52.128A7.366 7.366 0 0 1 41.805 164z",
    fill: "#DB0F00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcObesidad);
export default __webpack_public_path__ + "static/media/IMC_Obesidad.800468e8.svg";
export { ForwardRef as ReactComponent };